import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const complianceFormSectionHeaderStyles = {
  header: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 1,
  },
} as const;

export function ComplianceFormSectionHeader() {
  return (
    <Grid
      item={true}
      sx={complianceFormSectionHeaderStyles.header}
      component={'header'}
    >
      <Typography variant="h3">Validate your renters insurance</Typography>
      <Typography variant="body1">
        Link your policy to verify coverage.
      </Typography>
    </Grid>
  );
}
